import React from "react";
import { useI18n } from "@/contexts/I18nContext";

// PR 3 · rule 1 (Code Health Report V1 · B-1a): a test that reads journal lines says "not applicable" on a TB-only engagement
// (the backend's analysis_source.tb_only_fields: not_applicable "not_applicable_tb_only") — never a silent 0 / blank.
// ``status`` = the answer (or its status block); ``part`` "analytics" adds which parts of Analytics are TB figures.
export function isTbOnly(status) {
  return !!status && (status.not_applicable === "not_applicable_tb_only" || status.tb_only === true);
}

export default function TbOnlyNotice({ status, part, testid = "tb-only-notice" }) {
  const { t } = useI18n();
  if (!isTbOnly(status)) return null;
  return (
    <div role="status" data-testid={testid}
         className="rounded border border-amber-300 bg-amber-50 p-2 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/20 dark:text-amber-200">
      <div className="font-medium">{t("sbe.tbOnly.title")}</div>
      <div className="text-xs">{part === "analytics" ? t("sbe.tbOnly.analytics") : t("sbe.tbOnly.body")}</div>
    </div>
  );
}
